<template>
	
	<div style="width:760px;margin:5px 0px 0px 5px"><!-- 封装弹框 -->
	

      
           <el-table
			        :data="dataChildlist"
			        row-key="mem_id"
			        default-expand-all
			        :tree-props="{children: 'users'}"
			        border
			       :empty-text="$t('tableText.데이타가없습니다')"
			        v-loading="tableChildLoading"
			      >
 
        <el-table-column :label="$t('nav.아이디')" width="200" prop="mem_id" align="center">
          <template slot-scope="scope"><span @click="openIdModel(scope.row.mem_id)" class="text-primary" style="cursor:pointer">{{ scope.row.mem_id}} ({{ scope.row.mem_name}})</span></template>
        </el-table-column>
       

         

     <template v-if="this.aid!='soft10'">

           <el-table-column :label="$t('msg.카슬머니')" v-if="this.sitetype=='4'" prop="api_money" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.api_money)}}</template>
        </el-table-column>
         <el-table-column :label="$t('msg.게임머니')" prop="mem_cash" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>
        </el-table-column>
        <el-table-column :label="$t('nav.이벤트')" prop="mem_eventmoney" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.mem_eventmoney)}}</template>
        </el-table-column>
      
        </template>

        <template v-if="this.aid=='soft10'">

           <el-table-column :label="$t('msg.카슬머니')" v-if="this.sitetype=='4'" prop="api_money" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.api_money)}}</template>
        </el-table-column>
        
        <el-table-column :label="$t('msg.카슬롤링')" prop="mem_eventmoney" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.mem_eventmoney)}}</template>
        </el-table-column>
<template v-if="this.power=='1'">
        <el-table-column :label="$t('msg.파워머니')"  prop="power_cash" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.power_cash)}}</template>
        </el-table-column>
        
        <el-table-column :label="$t('msg.파워롤링')" prop="power_ecash" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.power_ecash)}}</template>
        </el-table-column>
      </template>
        </template>


       <el-table-column :label="$t('msg.총입금')"  prop="in_money" align="center" width="50">
          <template slot-scope="scope">{{ formatMoney(scope.row.in_money)}} </template>
        </el-table-column>
        <el-table-column :label="$t('msg.총출금')" prop="out_money" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.out_money)}}</template>
        </el-table-column>
      
      
        
       
      </el-table>
         
      


	</div>
</template>
<script>
 import layer from './layer.vue';
  import layerNew from '../../components/common/layer-new.vue';
	export default{
     components: {
      
      layer
    },
		props:{
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      layerid:{
        type:String,
        default:""
      },
		
		
		
		},
	
    	data(){
    		return{
        
    			dataChildlist:[],
    			tableChildLoading:false,
    			domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
    		aid:window.sessionStorage.getItem('admin_id'),
        power:window.sessionStorage.getItem('power'),
           
    			
    		}
    	},
        created() {
          // this.info.id父组件传给子组件的id值
          this.zpchildManage(this.info.id);

          
             
    },
    	methods:{
          openIdModel(id){

            if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: ['830px', '680px'],
             
             });
              return;
           }
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['830px', '680px'],
           
        });
        
        },
         zpchildManage(id){
          //console.log('id',id)
          this.tableChildLoading = true
          let token=window.sessionStorage.getItem('user');
                this.$axios({
                  method:'get',
                  url:this.domain+'/admin/memlist_by_shop?mem_id='+id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              this.tableChildLoading = false
             // console.log('data:===',response.data.data)
              let data = response.data.data
              this.dataChildlist = data
                  
                   
                
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
      },
          openIdModel(id){

            if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: ['830px', '680px'],
             
             });
              return;
           }
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['830px', '680px'],
           
        });
        
        },
    		Cancel(){
    			this.$emit('cancelData')
    		},
    		openSumzp(e){
          
        console.log('-',e)
        this.ChildVisible= true
        this.tableChildLoading = true

        let token=window.sessionStorage.getItem('user');
                this.$axios({
                  method:'get',
                  url:this.domain+'/admin/memlist_by_zp?mem_id='+e.row.mem_id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              this.tableChildLoading = false
             // console.log('data:===',response.data.data)
              let data = response.data.data
              this.dataChildlist = data
                  
                   
                
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
        

        },
    		Save() {
                this.$emit('submitData')
            },
            handleClose() {
                this.$emit('handleClose')
            }
    	
    	}
	}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/common/memlist_by_shop.vue